export const UnknownString = 'Unknown';

export default {
  UnknownString,
};
